import { baseConnectUrl } from '@square/dashboard-utilities/utils/url';
import Service from '@ember/service';
import { captureException, withScope } from '@sentry/ember';
export let BrandSource = /*#__PURE__*/function (BrandSource) {
  BrandSource[BrandSource["BRAND_SOURCE_UNSPECIFIED"] = 0] = "BRAND_SOURCE_UNSPECIFIED";
  BrandSource[BrandSource["BRAND_SOURCE_INTERNAL_API"] = 1] = "BRAND_SOURCE_INTERNAL_API";
  BrandSource[BrandSource["BRAND_SOURCE_ADMIN_DASHBOARD"] = 2] = "BRAND_SOURCE_ADMIN_DASHBOARD";
  BrandSource[BrandSource["BRAND_SOURCE_SQUARE_SELLER_SELF_ONBOARDING"] = 3] = "BRAND_SOURCE_SQUARE_SELLER_SELF_ONBOARDING";
  BrandSource[BrandSource["BRAND_SOURCE_C4B_CUSTOMER_MAPPING"] = 4] = "BRAND_SOURCE_C4B_CUSTOMER_MAPPING";
  BrandSource[BrandSource["BRAND_SOURCE_SQUARE_SELLER_MENU_PAGE"] = 5] = "BRAND_SOURCE_SQUARE_SELLER_MENU_PAGE";
  return BrandSource;
}({}); // The brand was onboarded by a Square seller visiting the Menu page in Dashboard.
export default class CashAppLocal extends Service {
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift();
    }
    return undefined;
  }
  createLocationConfigurationBody(orderingPaused, locationConfigurations) {
    if (locationConfigurations.length === 0) {
      // if no locations are provided, update the top-level ordering property
      return {
        ordering_paused: orderingPaused
      };
    }
    return {
      location_configurations: {
        location_configuration: locationConfigurations
      }
    };
  }
  async updateOrderingConfiguration(orderingPaused = true, locationConfigurations = []) {
    try {
      const csrfToken = this.getCookie('_js_csrf');
      if (!csrfToken) {
        this.captureException(new Error('CSRF token not found for updateOrderingConfiguration'));
        return null;
      }
      const urlPath = baseConnectUrl('/cash-app-local/seller/brand/ordering-configuration', true);
      const response = await fetch(urlPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'include',
        body: JSON.stringify(this.createLocationConfigurationBody(orderingPaused, locationConfigurations))
      });
      if (!response.ok) {
        const errorBody = await response.text();
        this.captureException(new Error(`Failed to update ordering configuration: ${response.status} - ${errorBody}`));
        return null;
      }
      return response.json();
    } catch (error) {
      this.captureException(new Error(`Exception in updateOrderingConfiguration: ${error}`));
      return null;
    }
  }
  async fetchDefaultBrand() {
    try {
      const csrfToken = this.getCookie('_js_csrf');
      if (!csrfToken) {
        this.captureException(new Error('CSRF token not found for fetchDefaultBrand'));
        return null;
      }
      const urlPath = baseConnectUrl('/cash-app-local/seller/merchant/default-brand', true);
      const response = await fetch(urlPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'include',
        body: JSON.stringify({})
      });
      if (!response.ok) {
        const errorBody = await response.text();
        this.captureException(new Error(`Failed to fetch default brand: ${response.status} - ${errorBody}`));
        return null;
      }
      return response.json();
    } catch (error) {
      this.captureException(new Error(`Exception in fetchDefaultBrand: ${error}`));
      return null;
    }
  }
  async onboardSquareMerchant(brandSource) {
    try {
      const csrfToken = this.getCookie('_js_csrf');
      if (!csrfToken) {
        this.captureException(new Error('CSRF token not found for onboardSquareMerchant'));
        return null;
      }
      const urlPath = baseConnectUrl('/cash-app-local/seller/merchant/onboard', true);
      const response = await fetch(urlPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'include',
        body: JSON.stringify({
          brand_source: brandSource
        })
      });
      if (!response.ok) {
        const errorBody = await response.text();
        this.captureException(new Error(`Failed to onboard square merchant: ${response.status} - ${errorBody}`));
        return null;
      }
      return response.json();
    } catch (error) {
      this.captureException(new Error(`Exception in onboardSquareMerchant: ${error}`));
      return null;
    }
  }
  captureException(error, context) {
    if (context) {
      withScope(scope => {
        scope.setContext('cashAppLocalContext', context);
        captureException(error);
      });
    } else {
      captureException(error);
    }
  }
}